<div>
  <form [hidden]="toggle.processing || !!favourite" [formGroup]="addHomeForm" (ngSubmit)="addHomeSubmit($event)">

    <header>
      <figure class="descriptor">
        <div class="aspect-ratio"></div>
        <div class="content">
          <ngx-picture class="contain" src="/assets/illustrations/get-started-Homes.svg"
            [lazyLoad]="true">
          </ngx-picture>
        </div>
      </figure>
      <div [ngSwitch]="toggle.signedIn">
        <span class="lib-spacer"></span>
        <h3 *ngSwitchCase="true">Add a home&nbsp;to<br>your&nbsp;favourites</h3>
        <h3 *ngSwitchCase="false">Sign up &amp; add home to your&nbsp;favourites</h3>
        <p>Add the homes you love from your preferred online estate agents like Zoopla or Rightmove, and we will let you know if they are
          eligible for a Proportunity&nbsp;Loan.

          <!-- <span class="lib-legend"><sup>1</sup></span> -->
        </p>
        <!-- <span class="lib-legend"><sup>1</sup> Subject to application</span> -->
        <span class="lib-spacer"></span>
      </div>
      <button class="lib-button-flat" pTrackEvent="click" pTrackAction="close_add_home" pTrackCategory="app_add_home"
        type="button" (click)="close($event)">
        <lib-icon name="close"></lib-icon>
      </button>
    </header>

    <nav class="lib-nav sub-nav" [hidden]="!!data?.url">
      <p class="lib-legend">Copy / paste link to the listing&nbsp;below</p>
    </nav>

    <lib-input formControlName="url" type="url"
      placeholder="i.e. https://www.rightmove.co.uk/property-for-sale/property-92880035.html"
      [theme]="validVariant(addHomeForm, 'url')" data-test="add-home-modal-input">
    </lib-input>

    <span class="lib-spacer-fixed"></span>

    <lib-input *ngIf="toggle.notSignedIn" formControlName="email" type="email" placeholder="Your email"
      [theme]="validVariant(addHomeForm, 'email')">
    </lib-input>

    <span class="lib-spacer-fixed"></span>

    <lib-input *ngIf="toggle.notSignedIn" type="email" placeholder="Confirm your email">
    </lib-input>

    <span class="lib-spacer-fixed"></span>

    <nav class="lib-nav">
      <lib-checkbox *ngIf="toggle.notSignedIn" formControlName="agree_tanc"
        [theme]="validVariant(addHomeForm, 'agree_tanc')">
        <span class="lib-legend">I agree to the <a pTrackEvent="click" pTrackAction="terms" pTrackCategory="app_auth"
            href="https://www.proportunity.com/terms-and-conditions"
            target="_blank">terms&nbsp;&amp;&nbsp;conditions</a></span>
      </lib-checkbox>
      <span class="lib-spacer"></span>
      <lib-button pTrackEvent="click" pTrackAction="add_home" pTrackCategory="app_add_home" type="submit"
        theme="flat-primary" testAttribute="add-home-modal-button">
        Add home
      </lib-button>
    </nav>

  </form>

  <div class="processing" [hidden]="!toggle.processing">
    <nav class="lib-nav">
      <lib-icon name="searching"></lib-icon>
      <h6>Analysing home</h6>
      <span class="lib-legend">{{analysing || 'This may take a while...'}}</span>
      <!-- <p></p> -->
    </nav>
    <progress></progress>
    <!-- <figure>
      <div class="aspect-ratio square"></div>
      <div class="content">
        <ngx-picture class="contain" src="assets/animation.gif" ></ngx-picture>
      </div>
    </figure> -->
  </div>

  <div class="result" [hidden]="!favourite" [ngSwitch]="!!favourite?.listing">

    <!-- <nav class="lib-nav">
      <lib-icon class="done" name="done"></lib-icon>
      <h6>Added to favourites</h6>
      <span class="lib-spacer"></span>
      <button class="lib-button-stroked" [hidden]="toggle.notSignedIn" (click)="openInFavourites($event)">
        <span>Open in favourites</span>
      </button>
    </nav> -->

    <div hidden *ngSwitchCase="true" class="lib-flex-column">
      <ul class="lib-nav">
        <li>
          <p class="lib-legend">
            {{!!favourite?.listing?.metadata?.num_bedrooms ? (favourite?.listing?.metadata?.num_bedrooms | bedroomCanonical) : '-'}}
          </p>
        </li>
        <p>&middot;</p>
        <li>
          <p class="lib-legend">
            {{!!favourite?.listing?.metadata?.property_type ? (favourite?.listing?.metadata?.property_type | propertyTypeCanonical) : '–'}}
          </p>
        </li>
        <p>&middot;</p>
        <li>
          <p class="lib-legend">
            {{!!favourite?.listing?.metadata?.surface_area?.sqm ? (favourite?.listing?.metadata?.surface_area?.sqm | unitConvert) : '–'}}
          </p>
        </li>
      </ul>
      <h6>{{favourite?.listing?.source_data?.displayable_address || favourite?.listing?.source_data?.address}}</h6>
      <ul class="lib-nav">
        <li class="lib-flex-column">
          <p class="lib-legend">
            <span
              [hidden]="!favourite?.listing?.metadata?.price_change_since_listed || favourite?.listing?.metadata?.price_change_since_listed >= 0">Discounted
              {{-favourite?.listing?.metadata?.price_change_since_listed | shortNumber}} since first listed
              {{favourite?.listing?.createdAt | date : 'MMM y'}}</span>
            <span
              [hidden]="!favourite?.listing?.metadata?.price_change_since_listed || favourite?.listing?.metadata?.price_change_since_listed < 0">
              First listed {{favourite?.listing?.createdAt | date : 'MMM y'}}</span>
          </p>
        </li>
      </ul>
    </div>

    <div *ngSwitchCase="false">

      <app-signup-success [email]="email" title="Home added successfully!" message="To log in and see eligibility"></app-signup-success>

      <!-- <p>Our experts are busy analysing your potential new home. To find out if it's eligible, check your email and
        activate your account.</p> -->
    </div>
  </div>
</div>
